import { Link } from "react-router-dom";
import { categories } from "@/utils/movie";

export default function Footer() {
  return (
    <footer className="mt-16 border-t border-background-200 bg-background-100">
      <div className="mx-auto w-full px-4 py-12 md:px-6">
        <div className="grid grid-cols-1 gap-8 md:grid-cols-4">
          <div>
            <div className="flex items-center gap-2">
              <span className="flex h-8 w-8 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-base font-bold text-foreground-950">
                免费<span className="text-accent-500">在线电影</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-foreground-600">
              汇聚最新高清电影资源，提供便捷的影片信息浏览与观看入口，让每一位影迷都能轻松找到属于自己的好电影。
            </p>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">热门分类</h3>
            <ul className="mt-4 grid grid-cols-2 gap-2">
              {categories.slice(0, 6).map((cat) => (
                <li key={cat.slug}>
                  <Link to={`/category/${cat.slug}`} className="text-sm text-foreground-600 transition-colors hover:text-accent-600">
                    {cat.name}电影
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">网站导航</h3>
            <ul className="mt-4 space-y-2">
              <li><Link to="/" className="text-sm text-foreground-600 transition-colors hover:text-accent-600">首页</Link></li>
              <li><Link to="/search" className="text-sm text-foreground-600 transition-colors hover:text-accent-600">搜索影片</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-600 transition-colors hover:text-accent-600">关于我们</Link></li>
              <li><Link to="/contact" className="text-sm text-foreground-600 transition-colors hover:text-accent-600">联系我们</Link></li>
            </ul>
          </div>

          <div>
            <h3 className="font-heading text-sm font-semibold text-foreground-950">友情链接</h3>
            <ul className="mt-4 space-y-2">
              <li><span className="text-sm text-foreground-600">光影资讯站</span></li>
              <li><span className="text-sm text-foreground-600">影视爱好者社区</span></li>
              <li><span className="text-sm text-foreground-600">高清片单推荐</span></li>
              <li><span className="text-sm text-foreground-600">导演与演员资料库</span></li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col items-center justify-between gap-3 border-t border-background-200 pt-6 sm:flex-row">
          <p className="text-xs text-foreground-500">
            © 2026 免费在线电影 · 本站为内容演示站点，所有影片信息仅供浏览参考
          </p>
          <p className="text-xs text-foreground-500">
            播放功能为前端演示，不提供真实视频源
          </p>
        </div>
      </div>
    </footer>
  );
}